import { makeStyles } from "@material-ui/core";
import BarChart, { BAR_DIRECTION } from "src/components/ScoringChart/BarChart";
import PaperWrapper from "src/components/Wrapper/PaperWrapper";
import { TOP_COLOR_LIST } from "src/config/styleConfig";
import { useReputationSelector } from "src/context/reputationContext";

const getOption = () => ({
  chart: {
    height: 300,
  },
  colors: TOP_COLOR_LIST.slice(1, 5).reverse(),
  title: {
    text: "",
  },
  xAxis: {
    categories: ["Rank 5", "Rank 4", "Rank 3", "Rank 2"],
  },
  yAxis: {
    tickAmount: 6,
    labels: {
      enabled: true,
    },
    title: {
      text: "Number of holders",
      align: "high",
    },
  },
  plotOptions: {
    bar: {
      dataLabels: {
        enabled: true,
        style: {
          fontSize: 13,
        },
      },
      borderWidth: 0,
      borderRadius: 2,
      colorByPoint: true,
    },
    series: {
      pointWidth: 20,
    },
  },
  tooltip: {
    enabled: true,
  },
});

const useStyles = makeStyles(() => ({
  root: {
    padding: "20px",
  },
}));

export default function StatisticalInformation() {
  const cls = useStyles();

  const holderSeries = useReputationSelector((state) => {
    let series = [];
    if (state.reputationRank) {
      series = [
        {
          name: "Holders",
          data: state.reputationRank.rank
            .map((item) => parseInt(item.number_of_holders))
            .slice(1, 5)
            .reverse(),
        },
      ];
    }
    return series;
  });

  return (
    <PaperWrapper title="Statistical Information" className={cls.root}>
      <BarChart
        series={holderSeries}
        categories={["Rank 5", "Rank 4", "Rank 3", "Rank 2"]}
        type={BAR_DIRECTION.HORIZONTAL}
        option={getOption()}
      />
    </PaperWrapper>
  );
}
